/**
 * Nightcap — Scroll-triggered fade-in animations
 * Uses IntersectionObserver to add .nc-fade-in--visible when elements enter viewport.
 */
(function () {
  'use strict';

  function initScrollAnimations() {
    var elements = document.querySelectorAll('.nc-fade-in:not(.nc-fade-in--visible)');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nc-fade-in--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  /* Re-initialize when theme editor loads/reloads sections */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.nc-fade-in:not(.nc-fade-in--visible)').forEach(function (el) {
        el.classList.add('nc-fade-in--visible');
      });
    });
  }
})();
